import React, { useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import { useEstimateList } from "../../../../Hooks/Features/Pocker/useEstimateList"
import CommonGrid from "../../../../components/CommonCompo/CommonGrid/CommonGrid";
import PanelHeaderTemplate from "../../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from "../../../../Hooks/Common/useCommon";
import { Menu } from "primereact/menu";
import RevokePopup from "../../../../components/Poker/RevokePopup";
import CommonFilterDropdown from "../../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
import { Dialog } from "primereact/dialog";
import TaskDetailsPopup from "../../../../components/TaskList/TaskDetailsPopup";

const EstimateList = () => {

  const { checkPermission, getValuePermission } = useCommon();
  const { tagRef, options, getEstimateDetails, columns, rowData, loader, handleFilterChange, handleExtendTime, menuItems, menuRef, revoke, setRevoke, handleRevoke, setCommonFilter, commonFilter, projectWiseData, expanded, setExpanded } = useEstimateList({ getValuePermission });
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

  return (
    <div ref={() => checkPermission("Estimate", tagRef)}>
      <div ref={tagRef} id='{"tabname": "bucket_planning", "data": "agileplanning_estimation_tab"}' >
        <div className="d-flex justify-content-between align-items-center my-3 px-3 gap-3">
          <div className="d-flex gap-3 align-items-center flex-grow-1">
            <h5 className="mb-0">Estimating</h5>
            <div style={{ width: "150px" }}>
              <input className="input-dd w100 mb-0" placeholder="Issue Key..." value={commonFilter?.issueKey} onChange={(e) => setCommonFilter({ ...commonFilter, issueKey: e.target?.value, isChange: true })} onBlur={() => { if (commonFilter?.isChange) { getEstimateDetails() } }} />
            </div>
            <span className="fw-semibold text-muted">{commonFilter?.totalTasks} Tasks</span>
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <button data-icon-only="true" data-action-type="default" onClick={() => getEstimateDetails()} title="Refresh"><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
            <button data-icon-only="true" data-action-type="default" onClick={() => setShowFiltersDrawer(true)} title="Filters"><FontAwesomeIcon icon="fa-solid fa-filter" /></button>
            {
              expanded ? (
                <button title="Collapse All" data-icon-only="true" data-action-type="default" onClick={() => setExpanded(false)}>
                  <FontAwesomeIcon icon="fa-solid fa-list" />
                </button>
              ) : (
                <button title="Expand All" data-icon-only="true" data-action-type="default" onClick={() => setExpanded(true)}>
                  <FontAwesomeIcon icon="fa-solid fa-expand" />
                </button>
              )
            }
            <div ref={() => checkPermission("Estimate", tagRef)}>
              <button ref={tagRef} id='{"tabname": "estimate", "data": "agileplanning_estimation_send_to_review_btn"}' title="Extend Estimate Time" data-icon-only="true" data-action-type="default" onClick={(e) => handleExtendTime(e)}><FontAwesomeIcon icon="fa-solid fa-clock" /></button>
            </div>
            <div ref={() => checkPermission("Estimate", tagRef)}>
              <button ref={tagRef} id='{"tabname": "estimate", "data": "agileplanning_estimation_send_to_review_btn"}' title="Revoke Selected" data-icon-only="true" data-action-type="delete" onClick={() => { handleRevoke() }}><FontAwesomeIcon icon="fa-solid fa-hand-point-left" /></button>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <CommonGrid columns={columns} data={rowData} expandAll={expanded} loader={loader} headerHeight={50} />
        </div>

        {revoke?.show && <RevokePopup showPopup={revoke} handleClose={() => setRevoke((prev) => ({ ...prev, show: false, data: [] }))} stage="estimating" apiCall={() => { getEstimateDetails(); setRevoke((prev) => ({ ...prev, show: false, data: [] })) }} />}

        <Menu className="survey-menu" model={menuItems} popup ref={menuRef} appendTo={document.body} />

        {/* Right Panel Filters Drawer */}
        <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
            <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                <div className="sk-drawer-header">
                    <h5 className="sk-drawer-title">Filters</h5>
                    <div className="d-flex align-items-center gap-2">
                        <button className="sk-drawer-clear-btn" onClick={() => {
                            setCommonFilter({
                                projects: [],
                                issueType: [],
                                issueKey: "",
                                isChange: true
                            });
                        }}>Clear All</button>
                        <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                            <FontAwesomeIcon icon="fa-solid fa-xmark" />
                        </button>
                    </div>
                </div>
                <div className="sk-drawer-body">
                    <div className='d-flex flex-column gap-4'>
                        {/* Dimensions Filter */}
                        <div className="sk-drawer-filter-group">
                            <div className="task-list-filter-label">Dimensions</div>
                            <div className="d-flex flex-column gap-2">
                                <MultiSelect
                                    options={options?.projects}
                                    optionLabel="project_name"
                                    optionValue="project_id"
                                    placeholder="Project"
                                    value={commonFilter?.projects}
                                    filter
                                    onChange={(e) => { setCommonFilter({ ...commonFilter, projects: e.value, isChange: true }) }}
                                    onHide={() => { handleFilterChange("projects") }}
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, "projects", commonFilter?.projects, () => setCommonFilter({ ...commonFilter, projects: [], isChange: true }))}
                                    className="sk-input-dd w-100"
                                />
                                <MultiSelect
                                    options={projectWiseData?.issueType}
                                    optionLabel="issue_type_name"
                                    optionValue="issue_type_id"
                                    placeholder="Task Type"
                                    value={commonFilter?.issueType}
                                    filter
                                    onChange={(e) => { setCommonFilter({ ...commonFilter, issueType: e.value, isChange: true }) }}
                                    onHide={() => { handleFilterChange("issueType") }}
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, "issueType", commonFilter?.issueType, () => setCommonFilter({ ...commonFilter, issueType: [], isChange: true }))}
                                    className="sk-input-dd w-100"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sk-drawer-footer">
                    <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                        getEstimateDetails();
                        setShowFiltersDrawer(false);
                    }}>Apply Filters</button>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default EstimateList